import { Directive, ElementRef, input, effect, inject } from '@angular/core';

const DATA_TEST_ATTRIBUTE = 'data-test';

@Directive({
  selector: '[dataTest]',
})
export class DataTestDirective {
  dataTest = input.required<string>();

  #elementRef = inject(ElementRef);

  constructor() {
    effect(() => {
      const testId = this.dataTest();
      if (testId) {
        this.#elementRef.nativeElement.setAttribute(DATA_TEST_ATTRIBUTE, testId);
      }
    });
  }
}
